// PromoDialogContent.js
import React from "react";
import {
  Box,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { setModalsState } from "../../../store/actions/uiActions/myPermitsActions";

const Vip = ({ handleTransition }) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);

  const dispatch = useDispatch();
  return (
    <>
      <DialogTitle
        mt={1}
        color="primary"
        variant="h4"
        id="responsive-dialog-title"
        sx={{ textAlign: "center" }}
      >
        VIP Offer. Don't Miss Out!{" "}
      </DialogTitle>
      <Typography color="primary" align="center" variant="h5" sx={{ px: 1 }}>
        Get Your NOC and All Your Building Permits Done Fast with AI Assistance!
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img
          alt="avatar_circle"
          src="/img/logos/logo_main.png"
          style={{ width: "15rem", height: "auto", zIndex: 2 }}
        />
      </Box>
      <DialogContent sx={{ px: 2 }}>
        <DialogContentText
          color="primary"
          variant="h6"
          sx={{ mb: 3, mt: 0, textAlign: "center" }}
        >
          What about letting Permit Rockstar help you complete all your building
          permit forms in addition to your NOC?
        </DialogContentText>
        <DialogContentText
          color="primary"
          sx={{ mb: 3, mt: 2, textAlign: "center" }}
        >
          Our advanced AI will hep you fill your forms in no time and we'll take
          care of gathering all the signatures needed and notarize them as
          required. Once the package is ready we will notify you or upload it
          for you.
        </DialogContentText>
        <DialogContentText
          color="primary"
          sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}
        >
          Save hundreds of dollars and 4 to 6 hours of your valuable time, by
          not having to search for information, fill forms, chase signatures
          around town, scanning and more.
        </DialogContentText>
        <DialogContentText
          color="primary"
          sx={{ textAlign: "center", fontWeight: "bold", px: 1 }}
        >
          <span style={{ fontSize: "26px", color: "#10b981" }}>Only</span>{" "}
          <span style={{ fontSize: "30px", color: "#10b981" }}>$</span>
          <span style={{ fontSize: "36px", color: "#10b981" }}>
            {currentUser?.service_tiers?.notary_record}
          </span>{" "}
        </DialogContentText>
        <DialogContentText
          color="primary"
          sx={{ mb: 5, textAlign: "center", fontWeight: "bold" }}
        >
          (Include all permit forms and NOC with notarization and recording)
        </DialogContentText>

        <Box
          sx={{
            gap: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Button
            color="success"
            onClick={async () =>
              await dispatch(setModalsState({ paymentModalOpen: true }))
            }
            fullWidth
            variant="contained"
          >
            YES, SAVE ME TIME AND MONEY
          </Button>
          <LoadingButton
            onClick={async () => {
              if (!currentUser?.tier?.monthly_restart) {
                await dispatch(setModalsState({ promoModalOpen: false }));
              } else {
                const totalNoc =
                  currentUser?.user?.analytics?.availableNocInPeriod;
                const usedNoc =
                  currentUser?.user?.analytics?.nocCreatedInPeriod;

                if (
                  parseInt(usedNoc) >= parseInt(totalNoc) ||
                  currentUser?.user?.analytics?.free_active === false
                ) {
                  handleTransition("nocPaymentPop");
                } else {
                  await dispatch(setModalsState({ promoModalOpen: false }));
                }
              }
            }}
            color="error"
            fullWidth
          >
            No, I don't want to save time and money
          </LoadingButton>
        </Box>
      </DialogContent>
    </>
  );
};

export default React.memo(Vip);
